import React, { ChangeEvent } from 'react';
import styled from 'styled-components';
import GlobalStyle from './GlobalStyle';

const InputWrapper = styled.div`
  position: relative;
  display: inline;
  float: left;
  margin-right: 7px;
  margin-top: 0px;
  height: 16px;
  label {
    margin: 0px !important;
    span {
      padding: 0;
      height: 18px;
      width: 18px;
      border: 2px solid #c3c3c3;
      border-radius: 5px;
      cursor: pointer;
      background-repeat: no-repeat;
      background-position: center center;
      transition: all 300ms;
      display: block;
      @media all and (max-width: 1439px),
        (max-height: 729px),
        (-webkit-device-pixel-ratio: 1.25) {
        height: 14px;
        width: 14px;
        padding: 6px;
        background-size: 10px;
      }
    }
  }
`;

type Props = {
  checked?: boolean;
  name?: string;
  onChangeCheckBox: (e: ChangeEvent<HTMLInputElement>) => void;
} & typeof defaultProps;

const defaultProps = {
  checked: false,
  name: '',
};

const Checkbox = function Checkbox(props: Props) {
  const { onChangeCheckBox } = props;

  return (
    <>
      <GlobalStyle />
      <InputWrapper>
        <label htmlFor="checkbox">
          <input {...props} type="checkbox" id="checkbox" onChange={onChangeCheckBox} className="checkbox-input-login" />
          <span />
        </label>
      </InputWrapper>
    </>
  );
};

Checkbox.defaultProps = defaultProps;

export default Checkbox;
